import { IconBurgerInHand } from 'components/icons/burger-in-hand';
import { IconFries } from 'components/icons/fries';
import { IconLook } from 'components/icons/look';
import { IconSad } from 'components/icons/sad';
import { IconSpill } from 'components/icons/spill';

export const DEFAULT_ICON = IconFries;
export const NEARBY_ERROR_ICON = IconSpill;
export const NEARBY_NO_STORES_ICON = IconSad;
export const NEARBY_NO_LOCATION_ICON = IconLook;
export const FAVORITES_ERROR_ICON = IconSpill;
export const FAVORITES_NO_AUTH_ICON = IconBurgerInHand;
export const FAVORITES_NO_STORES_ICON = IconBurgerInHand;
export const RECENT_ERROR_ICON = IconSpill;
export const RECENT_NO_AUTH_ICON = IconFries;
export const RECENT_NO_STORES_ICON = IconFries;
